import type { PropsWithChildren } from "react";
import { useEffect } from "react";

import { useThemeStore } from "@/shared/stores/themeStore.js";

export function ThemeProvider({ children }: PropsWithChildren) {
  const theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    if (theme === "default") {
      document.documentElement.removeAttribute("data-theme");
    } else {
      document.documentElement.dataset.theme = theme;
    }
  }, [theme]);

  return children;
}
